function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSelectDownArrow = function SvgSelectDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 17 10"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m-3.5 3.571 7.478 7.858L11.5 3.571",
    style: {
      fill: "none",
      stroke: "#5b3552",
      strokeWidth: "1.5px"
    },
    transform: "translate(4.5 -2.5)"
  }));
};
export { SvgSelectDownArrow as ReactComponent };
export default __webpack_public_path__ + "images/select-down-arrow.svg";